import { onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase-config";
import { useNavigate } from "react-router-dom";
import Editor from "../components/Editor";
import { addDoc, collection, doc, getDoc, getDocs, orderBy, query, setDoc, where } from "firebase/firestore";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from '../redux/userReducer'
import { getFirebaseDocs, getUrlParams, randomString } from '../common'
import Header from '../components/Header'
import Tabs from "../components/Tabs";
import Input from "../components/Input";
import MyDropzone from "../components/MyDropzone";

const TestingSubcategory = () => {


    const [editId, setEditId] = useState(false)
    const [isAdding, setIsAdding] = useState(false)
    const [name, setName] = useState('')
    const [priority, setPriority] = useState(1)
    const [icon, setIcon] = useState('')
    const [audio, setAudio] = useState('')

    const [loading, setLoading] = useState(false)
    const [mode, setMode] = useState('')
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [subcategories, setSubcategories] = useState([])

    const userInfo = useSelector(state => state.user.user)


    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                const uid = user.uid
                if (!userInfo) {
                    getUserInfo(uid)
                }
            } else {
                // User is signed out
                navigate('/login')
                // ...
            }
        })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        if (userInfo && userInfo.role === 'admin') {
            fetchSubCategories()
        }
    }, [userInfo])

    const getUserInfo = async (uid) => {
        // console.log('uid', uid)
        setLoading(true)
        const userData = await (await getDoc(doc(db, 'users', uid))).data()
        if (!userData) {
            toast.error('User doesn\'t exist. Taking you to login page.')
            setLoading(false)
            setTimeout(async () => {
                await signOutUser()
                navigate('/login')
            }, 3000)
            return
        }
        dispatch(setUser({ ...userData, id: uid }))
    }

    const signOutUser = async () => {
        await auth.signOut();
    }

    const fetchSubCategories = async () => {
        const params = getUrlParams()
        if (!params || !params.category) {
            navigate('/')
            return
        }
        const categoryInfo = await (await getDoc(doc(db, 'testing-categories', params.category))).data()
        setMode(categoryInfo.name)
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, 'testing-subcategories'), where('parentId', '==', params.category), orderBy('priority', 'desc'))))
        setSubcategories(docs)
    }

    const saveCategory = async () => {
        const params = getUrlParams()


        if (editId) {
            await setDoc(doc(db, 'testing-subcategories', editId), { name, icon, audio: audio || '', parentId: params.category, priority: parseInt(priority) })
        } else {
            await addDoc(collection(db, 'testing-subcategories'), { name, icon, audio: audio || '', parentId: params.category, priority: parseInt(priority) })
        }
        setIsAdding(false)
        setEditId('')
        fetchSubCategories()
    }

    return <div className="container">
        <Header />
        {isAdding ? <>
            <h2>Add a {mode} Testing Subcategory</h2>
            <Input bold type={'text'} errorMessage={''} errors={[]} name={'name'} value={name} setValue={setName} label={'Name'} />
            <Input bold type={'text'} errorMessage={''} errors={[]} name={'priority'} value={priority} setValue={setPriority} label={'Priority'} />

            <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Audio</label>
            <MyDropzone storageLocation={`Categories/${randomString()}`} allowAudio customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'icon'} image={audio} updateImage={(doc) => setAudio(doc)} />

            {<>
                <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Upload icon</label>
                <MyDropzone storageLocation={`Categories/${randomString()}`} customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'icon'} image={icon} updateImage={(doc) => setIcon(doc)} />
            </>}

            <div style={{ width: '200px', margin: '10px auto', display: 'flex', flexDirection: 'column' }}>
                <button disabled={!name || !priority || !parseInt(priority)} onClick={saveCategory}>Save</button>
                <button style={{ margin: '20px auto' }} className="textButton" onClick={() => setIsAdding(false)}>Cancel</button>
            </div>

        </> : <>
            {/* <Tabs tabs={modes} currentTab={mode} setCurrentTab={setMode} /> */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <button className="textButton" style={{ marginLeft: '0' }} onClick={() => navigate('/testing')}> {'←Back'}</button>
                <button className="textButton" style={{ marginLeft: 'auto' }} onClick={() => setIsAdding(true)}>+ Add New</button>
            </div>

            <h2>{mode} Category</h2>
            <table>
                <thead>
                    <tr>
                        <th>
                            Name
                        </th>
                        <th>
                            Icon
                        </th>
                        <th>
                            Priority
                        </th>
                        <th>
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {subcategories.map(({ id, name, priority, icon, audio }) => <tr key={id}>
                        <td>
                            {name}
                        </td>
                        <td>
                            <img src={icon} style={{ width: '100px', height: '100px' }} />
                        </td>
                        <td>
                            {priority}
                        </td>
                        <td>
                            <div style={{ display: 'flex' }}>
                                <button className="textButton" onClick={() => navigate(`/testingActivity?subcategory=${id}`)}>View</button>
                                <button className="textButton" onClick={() => { setIsAdding(true); setPriority(priority); setEditId(id); setName(name); setIcon(icon); setAudio(audio) }}>Edit</button>
                            </div>
                        </td>
                    </tr>)}
                </tbody>
            </table>
        </>}
        {/* <Editor /> */}
    </div>
}

export default TestingSubcategory